import { gql } from '@apollo/client';

export const GET_QUIZZES = gql`
  query GetQuizzes($filter: QuizFilter) {
    getQuizzes(filter: $filter) {
      quizzes {
        id
        title
        description
        publishStatus
        createdAt
        intervalTime
        questionInterval
        quizStartTime
        totalNoQuestion
        totalNoSession
        marksPerQuestion
        quizInitialDelay
        slug
        questions {
          id
          title
          type
          optionsValues {
            id
            title
          }
          correctAnswer
          createdAt
        }
        createdBy
        instruction
        modeOfConduct
        configId
      }
      count
    }
  }
`;

export const GET_SINGLE_QUIZ_BY_ID = gql`
  query getQuizById($data: GetQuizByIdInputType) {
    getQuizById(data: $data) {
      quiz {
        description
        publishStatus
        marksPerQuestion
        intervalTime
        instruction
        questions {
          type
          title
          correctAnswer
          optionsValues {
            id
            title
          }
          createdAt
          id
        }
        quizInitialDelay
        title
        id
        modeOfConduct
      }
    }
  }
`;

export const GET_SESSIONS = gql`
  query GetSessions($data: GetSessionsInput, $filter: SessionFilter) {
    getSessions(data: $data, filter: $filter) {
      count
      sessions {
        id
        highestScore
        totalUsers
        sessionDate
        slug
      }
    }
  }
`;
export const GET_PARTICIPANTS = gql`
  query GetParticipants(
    $data: GetParticipantsInput
    $filter: ParticipantsFilter
  ) {
    getParticipants(data: $data, filter: $filter) {
      count
      participants {
        sessionId
        userName
        score
        totalCorrectAnswers
      }
    }
  }
`;
